import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bscard',
	templateUrl:'./BSCardPluginCompPage.html',
	styles: [],
	styleUrls:['./BSCardPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSCardPluginCompPage
{
	mdContent_789 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.cards.BSCard;
\`\`\``;
	mdContent_790 = `\`\`\`java
BSCard()
\`\`\``;
	mdContent_791 = `\`\`\`java
BSCard(String text)
\`\`\``;
	mdContent_792 = `\`\`\`java
BSCard(boolean inverse)
\`\`\``;
	mdContent_793 = `\`\`\`java
BSCard&lt;?&gt; card = new BSCard&lt;&gt;();
card.addCardImageTop("/img/hero.jpg");
card.addCardHeader("Title");
card.addCardBody("Card content goes here.");
card.addCardFooter("Last updated 3 mins ago");
\`\`\``;
}
